<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Contacto</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-6 col-xs-12 col-sm-12">
          <contact-form ref="contactForm" @save="saveContact" />
        </div>
        <div class="col-md-6 col-xs-12 col-sm-12">
          <contacts-list :collapsed="false" :entity="entity" :entity-id="entityId" :edition="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ContactForm from './Forms/ContactForm';
import ContactsList from './List/ContactsList';

export default {
  name: 'ContactsCreate',
  components: {
    RouteBreadCrumb,
    ContactForm,
    ContactsList,
  },

  data() {
    return {
      entity: null,
      entityId: null,
    };
  },

  created() {
    this.entity = this.$route.meta.entity;
    this.entityId = +this.$route.params.id;
  },

  methods: {
    saveContact(contact) {
      this.$refs.contactForm.create(contact, this.entityId, this.entity);
    },
  },
};
</script>
